// extracted by mini-css-extract-plugin
export default {"coffee-logo":"CoffeeLogo_coffee-logo__5UnvB","small":"CoffeeLogo_small__csFkq"};